import { FormattedMessage } from 'react-intl';
import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { BORDER_DARK, VERY_LIGHT_GREY_COLOR } from '../../../const/color-const';

const styles = ((theme) => ({
  noData: {
    width: '100%',
    opacity: 0.6,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderTop: theme.palette.type === 'light' ? `1px solid ${VERY_LIGHT_GREY_COLOR}` : `1px solid ${BORDER_DARK}`,
    height: 42,
    '& h3': {
      margin: 0,
      fontSize: 14,
      [theme.breakpoints.up('md')]: {
        fontSize: 16,
      },
    },
  },
}));

const NoDataAvailable = ({ classes }) =>
  <div className={classes.noData}>
    <h3 className={classes.header}>
      <FormattedMessage
        id="page.dashboard.noDataAvailable"
        defaultMessage="No data available"
      />
    </h3>
  </div>;

export default withStyles(styles)(NoDataAvailable);